/**
 * @file topic-content-actions
 */
import {Url} from '@/utils/api.js';
import {get, post} from '@/utils/decorate/request';
import toast from '@/utils/decorate/toast';

export default {
    getTopicContent({commit}, query) {
        let url = Url.topicContentUrl;
        return get(url, query)
            .then(data => {
                if (Object.prototype.toString.call(data) === '[object Object]') {
                    // 兼容跳转帖子详情路由实际为issue的情况
                    // query.type !== 3 判断是否从非issue详情进入
                    // data.topicInfo.topicType === 3判断实际返回帖子是否为issue
                    if (query.type !== 3 && data.topicInfo.topicType === 3) {
                        return Promise.reject('issue not topic' + data.topicInfo.issueId);
                    }
                    commit('initTopicData', data);
                }
                else {
                    // 帖子不存在时状态码为200，返回数据为空数组
                    return Promise.reject();
                }
            });
    }
};
